<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-cubes mr-2" />Inventory Emas</h5>
            <hr />
            <b-row>
                <b-col md="9">
                    <div class="d-flex">
                        <b-input-group>
                            <b-input-group-prepend>
                                <b-button variant="dark" @click="showModalFilter">
                                    <i class="fa fa-search mr-2" />Filter...
                                </b-button>
                            </b-input-group-prepend>
                            <b-form-input v-model="filter.noFaktur" maxlength="50" placeholder="Cari No. Faktur..."
                                @keydown.enter="changeFilter()" />

                        </b-input-group>
                        <b-input-group class="ml-2">
                            <b-form-input v-model="filter.noFakturPEI" maxlength="50" placeholder="Cari No. Faktur..."
                                @keydown.enter="changeFilter()" />
                            <b-input-group-append>
                                <b-button variant="primary" @click="changeFilter()">Cari</b-button>
                            </b-input-group-append>
                        </b-input-group>
                        <b-input-group class="ml-2">
                            <b-button class="ml-2" variant="danger" @click="resetFilter">
                                Reset
                            </b-button>
                            <b-button variant="secondary" class="ml-2" @click="$bvModal.show('m-calculator')">
                                Kalkulator
                            </b-button>
                        </b-input-group>
                    </div>
                </b-col>
                <b-col md="3" class="text-right">
                    <b-dropdown
                        v-if="canAccessDownloadExcel"
                        variant="success"
                        id="dropdown-download-excel"
                    >
                        <template #button-content>
                            <i class="fa fa-download mr-2" />Download Excel
                        </template>
                        <b-dropdown-item v-if="canAccessStockGold" @click="downloadExcelStock">
                            Stock Barang
                        </b-dropdown-item>
                        <b-dropdown-item v-if="canAccessSimulationPrice" @click="openSimulationPriceModal">
                            Simulasi Harga
                        </b-dropdown-item>
                    </b-dropdown>
                </b-col>
            </b-row>
            <template v-if="initTable">
                <b-table bordered hover show-empty no-local-sorting :busy="isBusy" :items="items" :fields="fields"
                    @sort-changed="onSortChanged" responsive class="my-3">
                    <template v-slot:empty>
                        Tidak ada data inventory.
                    </template>
                    <template v-slot:cell(item)="row">
                        {{ row.item.type }} <span v-if="row.item.year != null">({{ row.item.year }})</span>
                        <div class="small">
                            {{ row.item.kind }} - {{ row.item.brand }} <br />
                            NF <strong style="cursor:pointer;" @click="copyToClipboard(row.item.no_faktur_pgi)">{{ row.item.no_faktur_pgi }}</strong> <i style="cursor:pointer;" @click="copyToClipboard(row.item.no_faktur_pgi)" class="fa fa-fw fa-copy" /><br />
                        </div>
                    </template>
                    <template v-slot:cell(price)="row">
                        <!-- check if item is sold show the price -->
                        <div v-if="isStatusAllowed(row.item.status)">
                            Rp. {{ $helper.formatThousand(row.item.sold_price) }}
                        </div>
                        <div v-else>
                            -
                        </div>
                        <div class="small">
                            Kloter {{ $helper.parseDate(row.item.created) }}<br />
                            {{ row.item.source || "-" }}
                        </div>
                    </template>
                    <template v-slot:cell(detail)="row">
                        <div class="small">
                            {{ row.item.warehouse == null ? "-" : "Gudang " + row.item.warehouse }} - {{ row.item.office
                            }}
                        </div>
                    </template>
                    <template v-slot:cell(status)="row">
                        <b-badge :variant="parseStatus(row.item.status, 0)">{{ parseStatus(row.item.status, 1)
                            }}</b-badge>
                    </template>
                    <template v-slot:cell(action)="row">
                        <b-button size="sm" variant="primary" v-b-tooltip.hover.top title="Detail"
                            @click="showDetail(row.item)">
                            <i class="fa fa-fw fa-info" />
                        </b-button>
                        <b-button size="sm" class="ml-2" variant="dark" v-b-tooltip.hover.top title="Gambar Fisik"
                            :disabled="isSubmitting" @click="prepareImage(row.item, 'fisik')">
                            <i class="fa fa-fw fa-picture-o" />
                        </b-button>
                        <b-button size="sm" v-if="isPrintAllowed(row.item)" class="ml-2" variant="dark"
                            v-b-tooltip.hover.top title="Print Barcode" @click="prepareReprint(row.item.id)">
                            <i class="fa fa-fw fa-print" />
                        </b-button>
                        <b-button size="sm" v-if="isMoveInventoryAllowed && isMoveAllowed(row.item)" class="ml-2"
                            variant="warning" v-b-tooltip.hover.top title="Pindah Gudang"
                            @click="prepareMove(row.item)">
                            <i class="fa fa-fw fa-truck" />
                        </b-button>
                        <b-button size="sm" v-if="isRequestResetAllowed && isResetAllowed(row.item)" class="ml-2"
                            variant="danger" v-b-tooltip.hover.top title="Request Edit Emas" @click="prepareReset(row.item)">
                            <i class="fa fa-fw fa-edit" />
                        </b-button>
                    </template>
                    <template #table-busy>
                        <div class="d-flex justify-content-center">
                            <b-spinner label="Loading..." />
                        </div>
                    </template>
                </b-table>
                <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange"
                    @page-change="onPageChange" />
            </template>
            <div class="d-flex justify-content-center mt-3">
                <b-spinner v-if="isLoadingTable && !initTable" label="Loading..." />
            </div>
        </b-card>
        <b-modal id="m-detail" title="Detail Inventory" size="lg" no-close-on-backdrop no-close-on-esc hide-footer>
            <DetailInventory :id="activeId" />
        </b-modal>
        <b-modal id="m-reprint-code" title="Reprint Barcode" centered no-close-on-backdrop hide-footer
            @shown="$refs.passcode.focus()">
            <b-form-group label="Passcode Reprint">
                <b-form-input type="password" ref="passcode" maxlength="10" v-model="passcode"
                    @keydown.enter="getReprintBarcode" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="getReprintBarcode">
                    {{ isSubmitting ? "Mengambil..." : "Reprint" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-reprint-barcode" title="Reprint Barcode" no-close-on-backdrop no-close-on-esc hide-footer
            hide-header-close>
            Silahkan cetak barcode dibawah ini. Mohon pastikan barcode tercetak dengan baik sebelum melanjutkan.
            <br /><br />
            <iframe :src="getBarcodeLink()" height="300px" width="100%" />
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button variant="dark" :disabled="barcodeToggleCooldown" @click="toggleBarcodeType">
                            Print {{ barcodeType == 'barcode' ? 'Mini' : 'Barcode' }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button variant="primary" @click="$bvModal.hide('m-reprint-barcode')">
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
        <b-modal id="m-move" title="Pindah Gudang" no-close-on-backdrop no-close-on-esc hide-footer>
            {{ activeItem.type }} - NF {{ activeItem.no_faktur_pgi }}<br /><br />
            <b-form-group label="Pindahkan ke...">
                <b-form-select v-model="input.warehouse" :options="optWarehouse" text-field="name" value-field="id">
                    <template #first>
                        <b-form-select-option value=0 disabled>Pilih Gudang...</b-form-select-option>
                    </template>
                </b-form-select>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="promptMove">
                    {{ isSubmitting ? "Memindahkan..." : "Pindahkan" }}
                </b-button>
            </div>

        </b-modal>
        <b-modal id="m-barcode" title="Cetak Barcode" centered no-close-on-backdrop no-close-on-esc hide-footer
            hide-header-close>
            Silahkan cetak barcode dibawah ini. Mohon pastikan barcode tercetak dengan baik sebelum melanjutkan.
            <br /><br />
            <iframe :src="getBarcodeMoveLink()" height="300px" width="100%" />
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button variant="dark" :disabled="barcodeToggleCooldown" @click="toggleBarcodeMoveType">
                            Print {{ barcodeMoveType == 'barcode' ? 'Kerusakan' : 'Barcode' }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button variant="primary" @click="$bvModal.hide('m-barcode')">
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
        <b-modal id="m-filter" title="Filter Pencarian" size="lg" no-close-on-backdrop no-close-on-esc hide-footer>
            <strong>DATA BARANG</strong>
            <b-row class="mt-1">
                <b-col md="6">
                    <b-form-group label="Nama Barang">
                        <b-form-input v-model="filter.name" maxlength="50" />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="No. Faktur PGI">
                        <b-form-input v-model="filter.noFaktur" maxlength="50" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <b-form-group label="Jenis">
                        <multiselect v-model="filter.kind" label="name" track-by="id" :internal-search="true"
                            deselect-label="" select-label="" :options="optKind" />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Merk">
                        <multiselect v-model="filter.brand" label="name" track-by="id" :internal-search="true"
                            deselect-label="" select-label="" :options="optBrand" />
                    </b-form-group>
                </b-col>
            </b-row>
              <b-row>
                <b-col md="6">
                    <b-form-group label="No. Faktur">
                        <b-form-input v-model="filter.noFakturPEI" maxlength="50" />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="No. Faktur Original">
                        <b-form-input v-model="filter.noFakturOri" maxlength="50" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <b-form-group label="Tahun">
                        <b-form-select v-model="filter.year" :options="yearOptions">
                            <template #first>
                                <b-form-select-option :value="null">-- Semua Tahun --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <hr />
            <strong>PENILAIAN DAN STATUS BARANG</strong>
            <b-row class="mt-1">
                <b-col md="6">
                    <b-form-group label="Status">
                        <multiselect :multiple="true" :close-on-select="false" v-model="filter.status" label="name"
                            track-by="id" :internal-search="true" deselect-label="" select-label=""
                            :options="optStatus" />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Gudang">
                        <multiselect v-model="filter.warehouse" label="name" track-by="id" :internal-search="true"
                            deselect-label="" select-label="" :options="optWarehouse" />
                    </b-form-group>
                </b-col>
            </b-row>
            <hr />
            <strong>KLOTER PENGIRIMAN</strong>
            <b-row class="mt-1">
                <b-col md="4">
                    <b-form-group label="Dari">
                        <b-form-input type="date" v-model="filter.from" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Sampai">
                        <b-form-input type="date" v-model="filter.to" />
                    </b-form-group>
                </b-col>
            </b-row>
            <div class="mt-4 text-right">
                <b-button variant="danger" @click="resetFilter">
                    Reset Filter
                </b-button>
                <b-button variant="primary" class="ml-3" @click="getItems()">
                    Cari
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-download-report"
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            hide-header-close
            ref="downloadModal"
            >
            <template #modal-title>
                Download Excel Stock
                <button
                    type="button"
                    class="close"
                    aria-label="Close"
                    :disabled="fetchReportStatus == 0"
                    @click="$refs.downloadModal.hide()"
                    style="position: absolute; top: 0.5rem; right: 1rem;">
                    <b-spinner small v-if="fetchReportStatus == 0" />
                    <span v-else aria-hidden="true">&times;</span>
                </button>
            </template>
            <div v-if="fetchReportStatus == 0">Menyiapkan laporan, mohon menunggu...</div>
            <div v-else-if="fetchReportStatus == -1">Gagal mendapatkan laporan, mohon coba kembali!</div>
            <div v-else>
                Silahkan tekan tombol dibawah ini untuk download laporan.
                <div class="mt-2">
                    <a :href="reportPath" download>
                        <b-button variant="success">
                            <i class="fa fa-download mr-2" />Download
                        </b-button>
                    </a>
                </div>
            </div>
        </b-modal>
        <b-modal id="m-download-simulation-price" title="Download Simulasi Harga" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Jumlah Harga Simulasi">
                <b-input-group prepend="Rp.">
                    <b-form-input
                        type="text"
                        inputmode="numeric"
                        v-model="excel.amount"
                        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                        @input="sanitizeSimulationAmount"
                        @keydown.enter="confirmDownloadExcelSimulationPrice"
                        placeholder="Masukkan jumlah harga simulasi" />
                </b-input-group>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="secondary" :disabled="isSubmitting" @click="$bvModal.hide('m-download-simulation-price')">
                    Batal
                </b-button>
                <b-button class="ml-2" variant="primary" :disabled="isSubmitting" @click="confirmDownloadExcelSimulationPrice">
                    <b-spinner small v-if="isSubmitting" class="mr-1" />
                    {{ isSubmitting ? "Menyiapkan..." : "Download" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-image-old" :title="'Edit Gambar Fisik Item ' + activeItem.type" size="xl"
            no-close-on-backdrop no-close-on-esc hide-footer>
            <b-row>
                <b-col cols="12" lg="8">
                    <div class="media-container">
                        <b-img-lazy v-if="mediaPreview.media == 'image'" class="media-preview"
                            :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url"
                            blank-src="image-loading.gif" block alt="Image Preview"></b-img-lazy>
                        <video v-else-if="mediaPreview.media == 'video'" class="media-preview" controls
                            :key="mediaPreview.url">
                            <source v-if="mediaPreview.type == 'video/webm'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url"
                                :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/ogg'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url"
                                :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/mp4'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url"
                                :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/3gpp'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url"
                                :type="mediaPreview.type">
                            <!-- <source v-else :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url" :type="mediaPreview.type"> -->
                            Your browser does not support the video tag.
                        </video>
                        <b-img-lazy v-else class="media-preview" src="/img/img-preview.png" block
                            alt="No Image"></b-img-lazy>
                    </div>
                    <div v-if="mediaPreview.title" class="d-flex justify-content-center my-3">
                        <h4>{{ mediaPreview.title || "-" }}</h4>
                    </div>
                    <div class="media-scroll">
                        <div class="media-scroll-content" v-for="(media, index) in filterMediaList" :key="'ms-' + index"
                            @click="onClickImage(media.url)">
                            <b-img-lazy class="media-scroll-preview" :class="{ active: media.isActive }"
                                :src="media.computedImageUrl || '/img/img-loading.gif'"
                                blank-src="/img/image-loading.gif" block :alt="media.altText"></b-img-lazy>
                            <!-- <b-img-lazy class="media-scroll-preview" :class="{ active: media.isActive }" src="https://sample-videos.com/img/Sample-png-image-5mb.png" blank-src="/img/image-loading.gif" block :alt="media.altText"></b-img-lazy> -->
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" lg="4" class="border-responsive">
                    <b-button block variant="primary"
                        :disabled="typeof (mediaPreview.url) === 'undefined' || isSubmitting"
                        @click="onOpenImage(mediaPreview.url)">
                        {{ isSubmitting ? "Menyimpan..." : "Tampilkan Item di Tab Baru" }}
                    </b-button>

                    <div class="mt-3 media-disclaimer" v-if="prepareImageType == 'kerusakan'">
                        <small>*Menu ini sudah tidak dapat digunakan untuk upload / delete gambar. Mohon menggunakan
                            menu gambar
                            pada adjustment barang.</small><br>
                    </div>
                    <div class="mt-3 media-disclaimer" v-else>
                        <small>*Jenis item gambar yang dapat diterima oleh sistem adalah format JPG, JPEG, dan
                            PNG.</small><br>
                        <small>*Maksimal ukuran total gambar untuk sekali upload sebesar 400MB.</small><br>
                        <small>*Minimal jumlah item gambar per inventori sebanyak 1 buah item.</small><br>
                        <small>*Maksimal jumlah item gambar per inventori sebanyak 10 buah item.</small>
                    </div>
                </b-col>
            </b-row>
            <div class="mt-4 text-right">
                <b-button variant="secondary" class="mr-2" :disabled="isSubmitting"
                    @click="$bvModal.hide('m-image-old')">
                    Batal
                </b-button>
            </div>
            <input multiple style="opacity: 0; filter:alpha(opacity=0);" ref="fileupload" type="file"
                @change="onUploadImage" accept="image/png, image/jpeg">
        </b-modal>
        <b-modal id="m-image"
            :title="'Edit Gambar Kerusakan Item ' + activeItem.type + ' (' + activeAdjustment.name + ')'" size="xl"
            no-close-on-backdrop no-close-on-esc hide-footer>
            <b-row>
                <b-col cols="12" lg="8">
                    <div class="media-container">
                        <b-img-lazy v-if="mediaPreview.media == 'image'" class="media-preview"
                            :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url"
                            blank-src="image-loading.gif" block alt="Image Preview"></b-img-lazy>
                        <video v-else-if="mediaPreview.media == 'video'" class="media-preview" controls
                            :key="mediaPreview.url">
                            <source v-if="mediaPreview.type == 'video/webm'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url"
                                :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/ogg'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url"
                                :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/mp4'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url"
                                :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/3gpp'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url"
                                :type="mediaPreview.type">
                            <!-- <source v-else :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url" :type="mediaPreview.type"> -->
                            Your browser does not support the video tag.
                        </video>
                        <b-img-lazy v-else class="media-preview" src="/img/img-preview.png" block
                            alt="No Image"></b-img-lazy>
                    </div>
                    <div class="media-scroll">
                        <div class="media-scroll-content" v-for="(media, index) in filterMediaList" :key="'ms-' + index"
                            @click="onClickImage(media.url)">
                            <b-img-lazy class="media-scroll-preview" :class="{ active: media.isActive }"
                                :src="media.media == 'video' ? '/img/video-thumbnail.png' : media.status == 'upload' ? media.url : media.url"
                                blank-src="/img/image-loading.gif" block :alt="media.altText"></b-img-lazy>
                            <!-- <b-img-lazy class="media-scroll-preview" :class="{ active: media.isActive }" src="https://sample-videos.com/img/Sample-png-image-5mb.png" blank-src="/img/image-loading.gif" block :alt="media.altText"></b-img-lazy> -->
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" lg="4" class="border-responsive">

                    <b-button block variant="warning" class="mb-2" @click="onRefreshImage()">
                        Refresh
                    </b-button>

                    <span v-show="!isUpload" id="uploadFile" class="my-2">
                        <b-button block variant="success">
                            {{ isSubmitting ? "Menyimpan..." : "Upload Item Gambar / Video Baru" }}
                        </b-button>
                    </span>

                    <div :key="uploadKey">
                        <div v-for="item in fileUploadResumable" :key="item.uniqueIdentifier">
                            <div v-if="item && item.status == 'uploading'">{{ item.fileName || "" }}
                                <uploading style="width:100%" :completedSteps="item.progress" />
                            </div>

                            <div v-if="item && item.status == 'retry'" class="text-center">
                                Sedang menghubungkan kembali, mohon menunggu...
                            </div>

                            <div v-if="item && item.status == 'error'" class="text-center">
                                Mengalami kesalahan, silahkan coba lagi.
                            </div>
                        </div>

                        <div v-if="finalizeBroken" class="text-center">Sedang proses finalisasi, mohon menunggu...</div>
                    </div>

                    <b-button block variant="primary" class="mt-2"
                        :disabled="typeof (mediaPreview.url) === 'undefined' || isSubmitting"
                        @click="onOpenImage(mediaPreview.url)">
                        {{ isSubmitting ? "Menyimpan..." : "Tampilkan Item di Tab Baru" }}
                    </b-button>
                    <b-button block variant="danger"
                        :disabled="typeof (mediaPreview.url) === 'undefined' || isSubmitting"
                        @click="onDeleteImage(mediaPreview.url)">
                        {{ isSubmitting ? "Menyimpan..." : "Hapus Item" }}
                    </b-button>
                    <div class="mt-3 media-disclaimer">
                        <small>*Jenis item gambar yang dapat diterima oleh sistem adalah format JPG, JPEG, dan
                            PNG.</small><br>
                        <small>*Jenis item video yang dapat diterima oleh sistem adalah format MP4, OGG, dan
                            WEBM.</small><br>
                        <small>*Maksimal ukuran total gambar / video untuk sekali upload sebesar 400MB.</small><br>
                        <small>*Minimal jumlah item gambar / video per inventori sebanyak 1 buah item.</small><br>
                        <small>*Maksimal jumlah item gambar / video per inventori sebanyak 10 buah item.</small>
                    </div>
                </b-col>
            </b-row>
            <input multiple style="opacity: 0; filter:alpha(opacity=0);" ref="fileupload" type="file"
                @change="onUploadImage" accept="image/png, image/jpeg, video/mp4, video/webm, video/ogg">
        </b-modal>

        <b-modal id="m-calculator" title="Kalkulator Harga Emas" no-close-on-backdrop centered no-close-on-esc hide-footer hide-header-close>
            <span>No Faktur</span>
            <div class="d-flex align-items-center mt-1">
                <b-form-input v-model="calculator.noFaktur" @keydown.enter="calculateGoldPrice"  placeholder="Masukkan No Faktur" />
                <b-button variant="primary" class="ml-3" @click="calculateGoldPrice">
                    <b-spinner small v-if="isSubmitting" />
                    <i class="fa fa-search" aria-hidden="true" v-else></i>
                </b-button>
            </div>

            <div class="mt-4 d-flex justify-content-end">
                <b-button variant="secondary" @click="closeModalCalculator">
                    Tutup
                </b-button>
            </div>
        </b-modal>

        <b-modal id="m-calculator-price-result" title="Kalkulator Harga Emas" no-close-on-backdrop
            centered no-close-on-esc hide-footer>
            <!-- if LM Retro and Perhiasan -->
            <div class="border p-3 rounded my-1" v-if="calculator.item.item_kind_id != 251">
                <div class="d-flex justify-content-between font-weight-bold">
                    <span>Jenis Emas:</span>
                    <span>{{ calculator.item.kind_name }}</span>
                </div>
                <div class="d-flex justify-content-between font-weight-bold">
                    <span>Kadar:</span>
                    <span>{{ calculator.item.purity }}</span>
                </div>
                <div class="d-flex justify-content-between font-weight-bold">
                    <span>Berat kering:</span>
                    <span>{{ calculator.item.dry_weight }} gr</span>
                </div>
                <div class="d-flex justify-content-between font-weight-bold">
                    <span>Potongan berat:</span>
                    <span>{{ calculator.item.weight_reduction }} gr</span>
                </div>
            </div>
            <!-- if LM Scan -->
            <div class="border p-3 rounded my-1" v-else>
                <div class="d-flex justify-content-between font-weight-bold">
                    <span>Jenis Emas:</span>
                    <span>{{ calculator.item.kind_name }}</span>
                </div>
                <div class="d-flex justify-content-between font-weight-bold">
                    <span>Brand:</span>
                    <span>{{ calculator.item.brand_name }}</span>
                </div>
                <div class="d-flex justify-content-between font-weight-bold">
                    <span>Tipe Emas:</span>
                    <span>{{ calculator.item.type_name }}</span>
                </div>
            </div>
            <div class="border p-3 rounded my-2 bg-gray">
                <div class="d-flex">
                    <h5>Hasil Perhitungan</h5>
                </div>
                <div v-if="calculator.item.item_kind_id != 251">
                    <div class="d-flex justify-content-between font-weight-bold my-1">
                        <span>Kadar / 1000:</span>
                        <span>{{ calculator.item.purity }} / 1000 = {{ calculator.item.purity / 1000 }}</span>
                    </div>

                    <div class="d-flex justify-content-between font-weight-bold my-1">
                        <span>Berat kering - Potongan berat:</span>
                        <span>{{ calculator.item.dry_weight }} gr - {{ calculator.item.weight_reduction }} gr = {{ netWeight }} gr</span>
                    </div>
                    <div class="d-flex justify-content-between font-weight-bold my-1">
                        <div class="d-flex flex-column">
                            <span>Harga Emas saat ini:</span>
                            <span class="small">Perubahan terakhir pada {{  $helper.parseDate(calculator.item.last_updated_at) }}, {{ $helper.parseHourMinute(calculator.item.last_updated_at) }}</span>
                        </div>
                        <span>Rp. {{ $helper.formatThousand(calculator.item.base_price) }}</span>
                    </div>
                    <hr />

                    <div class="d-flex justify-content-between font-weight-bold">
                        <span>Harga Total:</span>
                        <span>Rp.{{ $helper.formatThousand(calculator.item.total_price) }}</span>
                    </div>
                </div>
                <div v-else>
                    <div class="d-flex justify-content-between font-weight-bold my-1">
                        <span>Brand:</span>
                        <span>{{ calculator.item.brand_name}}</span>
                    </div>
                    <div class="d-flex justify-content-between font-weight-bold my-1">
                        <span>Tipe:</span>
                        <span>{{ calculator.item.type_name }}</span>
                    </div>
                    <hr />

                    <div class="d-flex justify-content-between font-weight-bold">
                        <span>Harga Total:</span>
                        <span>Rp.{{ $helper.formatThousand(calculator.item.total_price) }}</span>
                    </div>
                </div>
            </div>

        </b-modal>
        <ModalRequestEditEmas
            ref="modalRequestEditEmas"
            :item="activeItem"
            type="IVN"
            @refresh-items="getItems(currentPage)"
        />
    </div>
</template>

<script>
import DetailInventory from './DetailInventory.vue'
import lodash from 'lodash'
import Resumable from 'resumablejs';
import Uploading from './Uploading.vue'
import EnumPermissions from "@/shared/enum-permissions";
import ModalRequestEditEmas from "./ModalRequestEditEmas.vue";

export default {
    components: {
        DetailInventory,
        Uploading,
        ModalRequestEditEmas
    },
    data() {
        return {

            initStatus: 0,
            initTable: 0,
            isLoadingTable: false,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            isDownloadExcelAllowed: false,
            isMoveInventoryAllowed: false,
            isRequestResetAllowed: false,

            fetchReportStatus: 0,
            reportPath: "",

            activeId: 0,
            passcode: "",
            resetReason: "",
            resetType: "",

            filter: {
                name: "",
                kind: null,
                brand: null,
                warehouse: null,
                noFaktur: "",
                noFakturPEI: "",
                status: [],
                from: null,
                to: null,
                noFakturOri: null,
                year: null
            },

            input: {
                warehouse: 0,
            },

            inputColor: {},

            options: [
                { value: 10, text: '10' },
                { value: 20, text: '20' },
                { value: 30, text: '30' },
                { value: 40, text: '40' },
                { value: 50, text: '50' },
            ],

            fields: [
                { key: "item", label: "Barang", sortable: true },
                { key: "price", label: "Harga Jual", sortable: true },
                { key: "detail", label: "Detail", sortable: true },
                { key: "status", label: "Status", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            fieldsAdjust: [
                { key: "category", label: "Kategori", sortable: false, thClass: 'adjust-column-min' },
                { key: "name", label: "Keterangan", sortable: false, thClass: 'adjust-column-min' },
                { key: "adjustment", label: "Potongan / Tambahan Harga (Nominal)", sortable: false },
                { key: "adjustmentPercent", label: "Potongan / Tambahan Harga (Persen)", sortable: false },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: {},
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optKind: [],
            optBrand: [],
            optWarehouse: [],

            optStatus: [
                { id: 2, name: "READY" },
                { id: 7, name: "DRAFT" },
                { id: 3, name: "TERJUAL" },
                { id: 4, name: "RETUR" },
                { id: 5, name: "HILANG" },
                { id: 55, name: "REQUEST HILANG" },
                { id: 6, name: "KIRIM BALIK PGI" },
                { id: 66, name: "REQUEST KIRIM BALIK" },
                { id: 8, name: "REQUEST RESET" },
                { id: 9, name: "REQUEST MOVE" },
                { id: 10, name: "INVENTARIS" },
                { id: 11, name: "REQUEST INVENTARIS" },
                { id: 12, name: "DILEBUR" },
                { id: 13, name: "DIMURNIKAN" }
            ],

            mediaPreview: {},

            mediaList: [],

            isImageChanged: false,

            addAdj: {
                kind: null,
                optKind: [],
                category: null,
                name: null,
                optAdjustments: [],
                adjustment: "",
                adjustmentPercentage: ""
            },

            activeAdjustment: {},

            isChangeAdjustment: false,
            isChangePhotoAdjustment: false,

            prepareImageType: "",

            barcodeLink: "",
            barcodeLinkMini: "",
            barcodeMoveLink: "",
            barcodeMoveLinkDamage: "",

            barcodeType: 'barcode',
            barcodeMoveType: 'barcode',
            barcodeToggleCooldown: false,

            fileUploadResumable: [],
            resumable: false,
            uploadKey: 0,
            isUpload: false,

            activeAdjustmentRow: "",
            finalizeBroken: false,
            calculator: {
                noFaktur: "",
                item: {}
            },
            excel: {
                amount: null
            }
        }
    },

    watch: {

        "filter.kind": function (newVal) {

            this.filter.brand = null
            this.optBrand = []

            if (newVal != null) {

                this.$axios.get("master/brands/" + this.filter.kind.id).then(res => {
                    this.optBrand = res.data.data
                })

            }

        },
        filterMediaList: {
            handler(newVal) {
                newVal.forEach(media => {
                    if (!media.computedImageUrl) {
                        this.setImageSource(media);
                    }
                });
            },
            deep: true,
            immediate: true
        }

    },
    methods: {

        init() {

            this.initStatus = 0

            let getKinds = this.$axios.get("master/kinds?category=EMAS").then(res => {
                this.optKind = res.data.data;
            })

            let getWarehouses = this.$axios.get("master/warehouse/selection").then(res => {
                this.optWarehouse = res.data.data.map(it => {
                    return { id: it.id, name: it.name + " - " + it.office_name }
                })
            })

            Promise.all([getKinds, getWarehouses,]).then(() => {
                this.initStatus = 1
            })
                .catch(() => this.initStatus = -1)

        },

        showDetail(item) {
            this.activeItem = item
            this.activeId = item.id
            this.$bvModal.show("m-detail")
        },

        async changeFilter() {

            this.isLoadingTable = true

            await this.getItems()

            this.isLoadingTable = false

        },


        getItems(page = 1) {

            this.$bvModal.hide("m-filter")
            this.isBusy = true
            this.items = []
            this.initTable = 1

            if (isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)
            param += this.processFilter()

            if (!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("inventory/list/gold" + param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
                sessionStorage.setItem("listInventoryFilter", JSON.stringify(this.filter))



            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isBusy = false
                })

        },

        prepareReprint(id) {
            this.activeId = id
            this.$bvModal.show("m-reprint-code")
        },

        getBarcodeLink() {
            if (this.barcodeType == 'mini') {
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLinkMini}`
            }
            return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLink}`
        },

        toggleBarcodeType() {
            this.barcodeToggleCooldown = true
            if (this.barcodeType == 'barcode') this.barcodeType = 'mini'
            else this.barcodeType = 'barcode'
            setTimeout(function () {
                this.barcodeToggleCooldown = false
            }.bind(this), 2000);
        },

        getReprintBarcode() {

            this.isSubmitting = true
            let payload = {
                id: this.activeId,
                passcode: this.passcode
            }

            this.$axios.post("inventory/reprint-barcode", payload).then(res => {

                this.barcodeLink = res.data.data.link
                this.barcodeLinkMini = res.data.data.link_mini
                this.$bvModal.hide("m-reprint-code")
                this.$bvModal.show("m-reprint-barcode")
                this.passcode = ""

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        isPrintAllowed(item) {
            return ([2, 4, 7].includes(item.status) && !item.is_public) // Hanya READY / RETUR / DRAFT dan bukan item public (ecom)
        },

        downloadExcelStock() {

            this.fetchReportStatus = 0
            this.$bvModal.show("m-download-report")

            let param = this.processFilter()

            this.$axios.get("inventory/excel-stock/gold?" + param).then(res => {

                this.reportPath = res.data.data.path
                this.fetchReportStatus = 1

            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.fetchReportStatus = -1
                })
                .finally(() => this.isSubmitting = false)

        },

        openSimulationPriceModal() {
            this.excel.amount = null
            this.$bvModal.show("m-download-simulation-price")
        },

        sanitizeSimulationAmount() {
            const cleaned = String(this.excel.amount || "").replace(/\./g, "")
            this.excel.amount = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        },

        getParsedSimulationAmount() {
            const cleaned = String(this.excel.amount || "").replace(/\./g, "").replace(/(?!^-)[^0-9]/g, "")
            return Number(cleaned)
        },

        confirmDownloadExcelSimulationPrice() {
            const amount = this.getParsedSimulationAmount()

            if (!amount || amount <= 0) {
                return this.$helper.toastError(this, "Jumlah simulasi harus lebih dari 0")
            }

            this.$bvModal.hide("m-download-simulation-price")
            this.downloadExcelSimulationPrice()
        },

         downloadExcelSimulationPrice() {
            this.isSubmitting = true

            this.fetchReportStatus = 0
            this.$bvModal.show("m-download-report")

            const amount = this.getParsedSimulationAmount()

            const params = {
                amount
            }

            this.$axios.get("inventory/excel-simulation-price-gold", { params }).then(res => {

                this.reportPath = res.data.data.path
                this.fetchReportStatus = 1
                this.excel.amount = null

            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.fetchReportStatus = -1
                })
                .finally(() => this.isSubmitting = false)

        },

        isMoveAllowed(item) {
            return [2, 4].includes(item.status) // Hanya READY atau RETUR
        },

        prepareMove(item) {
            this.activeItem = item
            this.$bvModal.show("m-move")
        },

        getBarcodeMoveLink() {
            if (this.barcodeMoveType == 'barcode') {
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeMoveLink}`
            }
            else {
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeMoveLinkDamage}`
            }
        },

        toggleBarcodeMoveType() {
            this.barcodeToggleCooldown = true
            if (this.barcodeMoveType == 'barcode') this.barcodeMoveType = 'damage'
            else this.barcodeMoveType = 'barcode'
            setTimeout(function () {
                this.barcodeToggleCooldown = false
            }.bind(this), 2000);
        },

        promptMove() {

            let isConfirmed = confirm("Lakukan pemindahan?")
            if (!isConfirmed) return

            if (this.input.warehouse == 0) {
                return this.$helper.toastError(this, "Mohon memilih gudang tujuan!")
            }

            this.isSubmitting = true
            let payload = {
                id: this.activeItem.id,
                warehouse_id: this.input.warehouse
            }

            this.$axios.post("inventory/move-warehouse", payload).then(res => {

                this.$bvModal.hide("m-move")
                this.$helper.toastSuccess(this, "Barang berhasil dipindahkan!")

                let data = res.data.data
                this.activeItem.warehouse = data.name
                this.barcodeMoveLink = data.link
                this.barcodeMoveLinkDamage = data.linkDamage

                this.$bvModal.show("m-barcode")
                this.getItems(this.currentPage)

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        isResetAllowed(item) {
            return ([2, 4].includes(item.status) && !item.is_public) // Hanya READY atau RETUR dan bukan item public (ecom)
        },

        prepareReset(item) {
            this.activeItem = {
                ...item,
                no_faktur: item.no_faktur_pgi
            }
            this.$nextTick(() => {
                this.$refs.modalRequestEditEmas.$bvModal.show("m-request-edit-emas");
            });
        },

        sanitize(item) {

            let cleaned = String(item.adjustment).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            item.adjustment = res
            this.isChangeAdjustment = true

        },

        sanitizeString(str) {
            let cleaned = String(str).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            return res
        },

        prepareImage(item, type) {
            this.mediaPreview = {}
            this.mediaList = []
            this.prepareImageType = type
            this.activeItem = item
            this.isSubmitting = true
            let param = "?id=" + item.id
            if (type == 'kerusakan') {
                this.$axios.get("inventory-damaged-photo" + param).then(res => {
                    for (let i = 0; i < res.data.data.length; i++) {
                        let fileMedia = ''
                        let fileAltText = ''
                        if (res.data.data[i].type == 'image/jpeg' || res.data.data[i].type == 'image/png') {
                            fileMedia = 'image'
                            fileAltText = 'Upload Image Preview'
                        }
                        else if (res.data.data[i].type == 'video/mp4' || res.data.data[i].type == 'video/webm' || res.data.data[i].type == 'video/ogg' || res.data.data[i].type == 'video/3gpp') {
                            fileMedia = 'video'
                            fileAltText = 'Upload Video Preview'
                        }
                        else {
                            continue
                        }
                        let filenameSplit = res.data.data[i].path.split('/')
                        filenameSplit = filenameSplit[filenameSplit.length - 1].split('.')
                        let fileExtension = filenameSplit.pop()
                        let filename = filenameSplit.join()
                        this.mediaList.push({
                            id: res.data.data[i].id,
                            media: fileMedia,
                            type: res.data.data[i].type,
                            filename: filename,
                            extension: fileExtension,
                            url: res.data.data[i].path,
                            altText: fileAltText,
                            status: 'get',
                            isActive: false,
                            file: null
                        })
                    }
                    this.isImageChanged = false
                    this.$bvModal.show("m-image-old")
                })
                    .catch(error => this.$helper.parseError(this, error))
                    .finally(() => this.isSubmitting = false)
            } else if (type == 'fisik') {
                this.$axios.get("inventory-photo" + param).then(res => {
                    for (let i = 0; i < res.data.data.length; i++) {
                        let fileMedia = 'image'
                        let fileAltText = 'Upload Image Preview'
                        let filenameSplit = res.data.data[i].path.split('/')
                        filenameSplit = filenameSplit[filenameSplit.length - 1].split('.')
                        let fileExtension = filenameSplit.pop()
                        let filename = filenameSplit.join()
                        let fileType = ""

                        if (fileExtension == 'jpg' || fileExtension == 'jpeg' || fileExtension == 'png') {
                            fileMedia = 'image'
                            fileType = `image/${fileExtension}`
                            fileAltText = 'Upload Image Preview'

                        } else if (fileExtension == 'mp4' || fileExtension == 'webm' || fileExtension == 'ogg' || fileExtension == '3gpp') {
                            fileMedia = 'video'
                            fileType = `video/${fileExtension}`
                            fileAltText = 'Upload Video Preview'
                        } else {
                            continue
                        }


                        this.mediaList.push({
                            id: res.data.data[i].id,
                            media: fileMedia,
                            type: fileType,
                            filename: filename,
                            extension: fileExtension,
                            url: res.data.data[i].path,
                            urlCompress: this.modifyPathCompress(res.data.data[i].path_compress),
                            title: res.data.data[i].category.name || '-',
                            altText: fileAltText,
                            status: 'get',
                            isActive: false,
                            file: null
                        })
                    }
                    this.isImageChanged = false
                    this.$bvModal.show("m-image-old")
                })
                    .catch(error => this.$helper.parseError(this, error))
                    .finally(() => this.isSubmitting = false)
            }
        },

        prepareAdjImage(item) {
            this.activeAdjustmentRow = item
            this.mediaPreview = {}
            this.mediaList = []
            this.activeAdjustment = item.adjustmentSelect
            this.isSubmitting = true
            let param = "?inventory_id=" + this.activeItem.id
            param += "&adjustment_id=" + this.activeAdjustment.id
            this.$axios.get("adjustment-damaged-photo" + param).then(res => {
                for (let i = 0; i < res.data.data.length; i++) {
                    let fileMedia = ''
                    let fileAltText = ''
                    if (res.data.data[i].type == 'image/jpeg' || res.data.data[i].type == 'image/png') {
                        fileMedia = 'image'
                        fileAltText = 'Upload Image Preview'
                    }
                    else if (res.data.data[i].type == 'video/mp4' || res.data.data[i].type == 'video/webm' || res.data.data[i].type == 'video/ogg' || res.data.data[i].type == 'video/3gpp') {
                        fileMedia = 'video'
                        fileAltText = 'Upload Video Preview'
                    }
                    else {
                        continue
                    }
                    let filenameSplit = res.data.data[i].path.split('/')
                    filenameSplit = filenameSplit[filenameSplit.length - 1].split('.')
                    let fileExtension = filenameSplit.pop()
                    let filename = filenameSplit.join()
                    this.mediaList.push({
                        id: res.data.data[i].id,
                        media: fileMedia,
                        type: res.data.data[i].type,
                        filename: filename,
                        extension: fileExtension,
                        title: (res.data.data[i].category) ? res.data.data[i].category.name : '-',
                        url: res.data.data[i].path,
                        urlCompress: this.modifyPathCompress(res.data.data[i].path_compress),
                        altText: fileAltText,
                        status: 'get',
                        isActive: false,
                        file: null
                    })
                }
                this.isImageChanged = false
                this.$bvModal.show("m-image")

                setTimeout(() => {
                    this.initResumable()
                }, 1000)
            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)
        },

        onClickImage(url) {
            for (let i = 0; i < this.mediaList.length; i++) {
                this.mediaList[i].isActive = false
                if (this.mediaList[i].url == url) {
                    this.mediaList[i].isActive = true
                    this.mediaPreview = lodash.cloneDeep(this.mediaList[i])
                }
            }
        },

        onAddImage() {
            this.$refs.fileupload.click()
            this.isChangePhotoAdjustment = true
        },

        onUploadImage(e) {
            var files = e.target.files || e.dataTransfer.files
            if (!files.length) return
            // else if(files[0].size > this.$uploadLimit) {
            //     return
            // }
            if (this.filterMediaList.length + files.length > 10) {
                this.$helper.toastError(this, "Operasi Upload Dibatalkan! Jumlah gambar / video melebihi kapasitas maksimal 10 item per inventori.")
                return
            }
            for (let i = 0; i < files.length; i++) {
                let fileMedia = ''
                let fileAltText = ''
                if (files[i].type == 'image/jpeg' || files[i].type == 'image/png') {
                    fileMedia = 'image'
                    fileAltText = 'Upload Image Preview'
                }
                else if (files[i].type == 'video/mp4' || files[i].type == 'video/webm' || files[i].type == 'video/ogg') {
                    fileMedia = 'video'
                    fileAltText = 'Upload Video Preview'
                }
                else {
                    this.$helper.toastError(this, "Upload Item Gagal! Jenis file " + files[i].name + " tidak dikenali oleh sistem.")
                    continue
                }
                let filenameSplit = files[i].name.split('.')
                let fileExtension = filenameSplit.pop()
                let filename = filenameSplit.join()
                let fileResult = {
                    id: null,
                    media: fileMedia,
                    type: files[i].type,
                    filename: filename,
                    extension: fileExtension,
                    url: URL.createObjectURL(files[i]),
                    altText: fileAltText,
                    status: 'upload',
                    isActive: false,
                    file: files[i]
                }
                this.mediaList.push(fileResult)
                // for(let i = 0; i < this.mediaList.length; i++){
                //     this.mediaList[i].isActive = false
                // }
                // this.mediaPreview = lodash.cloneDeep(fileResult)
                this.isImageChanged = true
                this.$helper.toastSuccess(this, "Upload " + files[i].name + " berhasil!")
            }
            this.$refs.fileupload.value = null
        },

        onOpenImage(url) {
            window.open(url, '_blank')
        },

        onDeleteImage(url) {
            for (let i = 0; i < this.mediaList.length; i++) {
                if (this.mediaList[i].url == url) {
                    if (this.mediaList[i].status == 'get') {
                        this.mediaList[i].status = 'delete'


                        let payload = new FormData()

                        payload.append("inventory_id", this.activeItem.id)
                        payload.append("id_photo", this.mediaList[i].id)

                        this.$axios.post("adjustment-damaged-photo/delete", payload).then(() => {
                            this.$helper.toastSuccess(this, "Hapus Gambar Berhasil!")
                            // this.$bvModal.hide("m-image")
                            if (this.isChangePhotoAdjustment) {
                                this.isChangeAdjustment = true
                            }

                        })
                            .catch(error => this.$helper.parseError(this, error))
                    }
                    else {
                        this.mediaList.splice(i, 1)
                    }
                    this.isImageChanged = true
                    break
                }
            }
            this.mediaPreview = {}
            this.isChangePhotoAdjustment = true
        },

        // onSaveImage(id) {
        onSaveImage() {


            if (this.filterMediaList.length > 10) {
                this.$helper.toastError(this, "Operasi Save Dibatalkan! Jumlah gambar / video melebihi kapasitas maksimal 10 item per inventori.")
                return
            }

            this.isSubmitting = true

            let payload = new FormData()

            let deleteData = this.mediaList.filter(item => item.status == 'delete')

            let totalSize = 0

            for (let i = 0; i < this.fileUploadResumable.length; i++) {
                totalSize += this.fileUploadResumable[i].file.size
                if (totalSize > 419430400) {
                    this.$helper.toastError(this, "Operasi Save Dibatalkan! Total ukuran gambar / video melebihi kapasitas maksimal 400MB untuk sekali upload.")
                    return
                }
                payload.append("url[]", this.fileUploadResumable[i].url)
                payload.append("fileName[]", this.fileUploadResumable[i].fileNameUrl)
            }

            for (let i = 0; i < deleteData.length; i++) {
                payload.append("deletes[]", deleteData[i].id)
            }

            payload.append("inventory_id", this.activeItem.id)
            payload.append("adjustment_id", this.activeAdjustment.id)

            this.$axios.post("adjustment-damaged-photo/update", payload).then(() => {

                this.$helper.toastSuccess(this, "Update Gambar Berhasil!")
                this.$bvModal.hide("m-image")
                if (this.isChangePhotoAdjustment) {
                    this.isChangeAdjustment = true
                }

            })
                .catch(() => {
                    this.$helper.toastError(this, "Operasi Save Gagal! mohon dicoba kembali.")
                    this.$bvModal.hide("m-image")
                    this.initResumable()
                })
                .finally(() => {
                    this.isSubmitting = false
                    this.finalizeBroken = false
                })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        parseStatus(status, index) {
            switch (status) {
                case 2: return ["dark", "READY"][index]
                case 3: return ["success", "TERJUAL"][index]
                case 4: return ["warning", "RETUR"][index]
                case 5: return ["danger", "HILANG"][index]
                case 6: return ["primary", "KIRIM BALIK PGI"][index]
                case 66: return ["primary", "REQUEST KIRIM BALIK PGI"][index]
                case 7: return ["light", "DRAFT"][index]
                case 55: return ["dark", "REQUEST HILANG"][index]
                case 8: return ["dark", "REQUEST RESET"][index]
                case 10: return ["primary", "INVENTARIS"][index]
                case 11: return ["primary", "REQUEST INVENTARIS"][index]
                case 9: return ["primary", "REQUEST MOVE"][index]
                case 12: return ["danger", "DILEBUR"][index]
                case 13: return ["danger", "DIMURNIKAN"][index]
                default: return ["light", "-"][index]
            }
        },

        resetFilter() {

            this.filter = {
                name: "",
                kind: null,
                brand: null,
                warehouse: null,
                noFaktur: "",
                noFakturPEI: "",
                status: [],
                from: null,
                to: null,
                noFakturOri: null,
                year: null
            }

            this.getItems()

        },

        processFilter() {

            let param = ""

            if (!this.$helper.isBlank(this.filter.name)) {
                param += "&filter_name=" + this.filter.name
            }

            if (this.filter.kind != null) {
                param += "&filter_kind=" + this.filter.kind.id
            }

            if (this.filter.brand != null) {
                param += "&filter_brand=" + this.filter.brand.id
            }

            if (!this.$helper.isBlank(this.filter.noFaktur)) {
                param += "&filter_no_faktur=" + this.filter.noFaktur
            }

            if (!this.$helper.isBlank(this.filter.noFakturPEI)) {
                param += "&filter_no_faktur_pei=" + this.filter.noFakturPEI
            }

            if (!this.$helper.isBlank(this.filter.noFakturOri)) {
                param += "&filter_no_faktur_ori=" + this.filter.noFakturOri
            }

            if (this.filter.status.length != 0) {
                param += "&filter_status=" + this.filter.status.map(it => it.id).join()
            }

            if (this.filter.warehouse != null) {
                param += "&filter_warehouse=" + this.filter.warehouse.id
            }

            if (this.filter.from != null) {
                param += "&filter_from=" + this.filter.from
            }

            if (this.filter.to != null) {
                param += "&filter_to=" + this.filter.to
            }

            if (this.filter.year != null) {
                param += "&filter_year=" + this.filter.year
            }

            return param

        },

        showModalFilter() {
            this.$bvModal.show("m-filter")
        },

        modifyPathCompress(path) {
            if (/\/storage\//.test(path)) {
                return path;
            } else {
                return `/storage/${path}`;
            }
        },
        // finds the file in the local files array
        findFile(file) {
            return this.fileUploadResumable.find(item => item.uniqueIdentifier === file.uniqueIdentifier && item.status !== 'canceled') || {}
        },
        initResumable() {

            // init resumablejs on mount
            this.resumable = new Resumable({
                target: this.$BASE_UPLOAD_PATH,
                fileType: ['mp4', 'mov', 'png', 'jpg', 'jpeg'],
                chunkSize: 1 * 1024 * 1024, // default is 1*1024*1024, this should be less than your maximum limit in php.ini
                headers: {
                    'Accept': 'application/json'
                },
                query: {
                    feature: "adjdmgpht",
                },
                testChunks: false,
                throttleProgressCallbacks: 1,
                chunkRetryInterval: 5000,
            });

            // Resumable.js isn't supported, fall back on a different method
            if (!this.resumable.support) return alert('Your browser doesn\'t support chunked uploads. Get a better browser.');

            this.resumable.assignBrowse(document.getElementById('uploadFile'));
            this.resumable.assignDrop(document.getElementById('uploadFile'));

            let that = this

            // set up event listeners to feed into vues reactivity
            this.resumable.on('fileAdded', (file) => {
                file.hasUploaded = false
                this.isUpload = true

                that.fileUploadResumable.push({
                    file: file,
                    fileName: file.fileName,
                    uniqueIdentifier: file.uniqueIdentifier || "",
                    status: 'uploading',
                    progress: 0,
                    url: "",
                    fileNameUrl: ""
                })

                this.resumable.upload()

                this.uploadKey += 1
            })

            this.resumable.on('complete', () => {
                this.finalizeBroken = true
                this.onSaveImage()
                this.isUpload = false
                that.fileUploadResumable = []
            })

            this.resumable.on('fileSuccess', (file, event) => {
                let response = JSON.parse(event)

                this.findFile(file).status = 'success'
                this.findFile(file).url = response.data.path || ""
                this.findFile(file).fileNameUrl = response.data.filename || ""

                this.uploadKey += 1
            })
            this.resumable.on('fileError', (file) => {
                this.findFile(file).status = 'error'
                this.uploadKey += 1
            })
            this.resumable.on('fileRetry', (file) => {
                this.findFile(file).status = 'retry'
                this.uploadKey += 1
            })
            this.resumable.on('fileProgress', (file) => {

                const fileUpload = this.findFile(file)

                if (fileUpload.status !== 'canceled') {
                    fileUpload.status = 'uploading'
                    fileUpload.progress = Math.floor(file.progress() * 100)
                }

                this.uploadKey += 1

            })
        },

        onRefreshImage() {
            this.prepareAdjImage(this.activeAdjustmentRow)
        },

        copyToClipboard(text) {
            navigator.clipboard.writeText(text).then(() => {
                this.$helper.toastSuccess(this, "Berhasil menyalin teks ke clipboard!")
            }, () => {
                this.$helper.toastError(this, "Gagal menyalin teks ke clipboard!")
            })
        },
        async checkImgUrlStatus(url) {
            try {
                const response = await fetch(url, { method: 'HEAD' });
                return response.status === 200;
            } catch (error) {
                return false;
            }
        },
        async setImageSource(media) {
            let computedUrl;
            if (media.media == 'video') {
                computedUrl = '/img/video-thumbnail.png';
            } else if (media.status == 'upload') {
                computedUrl =  media.url;
            } else {
                const isUrlCompressAccessible = await this.checkImgUrlStatus(media.urlCompress);
                computedUrl = (isUrlCompressAccessible ? media.urlCompress : media.url);
            }
            this.$set(media, 'computedImageUrl', computedUrl);
        },
        isStatusAllowed(status) {
            const excludedStatuses = [2, 4, 7, 5, 55, 6, 66, 8, 9, 12, 13];
            return !excludedStatuses.includes(status);
        },
        closeModalCalculator() {
            this.calculator.noFaktur = null;
            this.$bvModal.hide("m-calculator");
        },
        calculateGoldPrice() {
            this.isSubmitting = true;
            if (this.$helper.isBlank(this.calculator.noFaktur)) {
                this.$helper.toastError(this, "Nomor faktur tidak boleh kosong");
                this.isSubmitting = false;
                return
            }

            const payload = {
                no_faktur: this.calculator.noFaktur
            }

            this.$axios.post("inventory/calculate-gold-price", payload).then(res => {
                this.calculator.item = res.data.data;

                this.$bvModal.show("m-calculator-price-result");
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false);
        },
        hasPermission(permissionId) {
            return (
                this.$helper.checkRoleNumber(
                    permissionId.toString(),
                    localStorage.getItem("permissions")
                ) || localStorage.getItem("roleName").includes("Superadmin")
            );
        },

    },
    computed: {
        yearOptions() {
            const current = new Date().getFullYear();
            const years = [];
            for (let y = current; y >= 2000; y--) {
                years.push(String(y));
            }
            return years;
        },
        filterMediaList() {
            return this.mediaList.filter(item => item.status != 'delete')
        },
        netWeight() {
            return (this.calculator.item.dry_weight - this.calculator.item.weight_reduction).toFixed(2);
        },
        canAccessSimulationPrice() {
            return this.hasPermission(EnumPermissions.SIMULASI_HARGA_EMAS)
        },
        canAccessDownloadExcel() {
            return this.hasPermission(EnumPermissions.INVENTORY_EMAS) || this.$helper.isAllowed(EnumPermissions.SIMULASI_HARGA_EMAS)
        },
        canAccessStockGold() {
            return this.hasPermission(EnumPermissions.INVENTORY_EMAS)
        }

    },
    created() {
        // if (!this.$helper.isBlank(sessionStorage.getItem("listInventoryFilter"))) {
        //     this.filter = JSON.parse(sessiotnStorage.getItem("listInventoryFilter"))
        // }
        this.init()

        this.isMoveInventoryAllowed = this.$helper.isAllowed(this.$helper.PERM_MOVE_INVENTORY)
        this.isRequestResetAllowed = this.hasPermission(EnumPermissions.RESET_INVENTORY_GOLD)
    }
}
</script>

<style scoped>

.bg-gray {
    background-color: rgba(245, 245, 245, .9) !important;
}

.media-container {
    height: 0;
    padding-top: 56.25%;
    position: relative;
}

.media-preview {
    max-height: 100%;
    max-width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #dee2e6;
    border-radius: .25rem;
    object-fit: cover;
    background-color: #dee2e6;
    left: 50%;
    transform: translateX(-50%);
}

:not(:root):-webkit-full-screen {
    object-fit: contain !important;
}

.media-scroll {
    margin-top: 10px;
    height: 70px;
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    background-color: #dee2e6;
    white-space: nowrap;
}

.media-scroll-content {
    display: inline-block !important;
    height: 100%;
    width: 20%;
}

.media-scroll-preview.active {
    border: 5px solid #65c2e4;
}

.media-scroll-preview:hover {
    opacity: 0.5;
}

.media-scroll-preview {
    height: 100%;
    width: 100%;
    border: 5px solid #dee2e6;
    border-radius: .25rem;
    object-fit: cover;
    background-color: #dee2e6;
    cursor: pointer;
}

.border-responsive {
    margin-top: 10px;
    border-top: 1px solid #c8ced3;
}

.media-disclaimer {
    text-align: justify;
    text-justify: inter-word;
}

@media only screen and (min-width: 576px) {
    .media-scroll {
        height: 100px;
    }
}

@media only screen and (min-width: 992px) {
    .border-responsive {
        margin-top: 0px;
        border-top: none;
        border-left: 1px solid #c8ced3;
    }
}

@media only screen and (min-width: 1200px) {
    .media-scroll {
        height: 150px;
    }
}
</style>
